import { CitationCard } from '../components/CitationCard';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './CitationsSection.module.css';

const DOI_URL = 'https://doi.org/10.1103/v93w-ytyc';
const PAPER_URL = 'https://journals.aps.org/prper/abstract/10.1103/v93w-ytyc';
const CEILS_URL =
  'https://ceils.ucla.edu/artificial-intelligence-and-math-skills-aims-in-physics-chemistry-and-life-sciences/';
const UCSD_URL =
  'https://today.ucsd.edu/story/study-finds-unique-strategies-to-improve-student-performance-on-physics-exams';

const sourceCards = [
  {
    eyebrow: 'Publication',
    href: PAPER_URL,
    link: 'View paper ↗',
    title: 'Phys. Rev. Physics Education Research',
  },
  {
    eyebrow: 'Program',
    href: CEILS_URL,
    link: 'Visit CEILS site ↗',
    title: 'UCLA CEILS - AIMS program',
  },
  {
    eyebrow: 'Press',
    href: UCSD_URL,
    link: 'Read the announcement ↗',
    title: 'UC San Diego coverage',
  },
];

export function CitationsSection() {
  return (
    <SectionWrapper background="soft" data-testid="research-section-citations">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>READ THE WORK</p>
          <h2 className={styles.title}>Citations and sources.</h2>
        </div>

        <CitationCard doiHref={DOI_URL} doiLabel="DOI: 10.1103/v93w-ytyc">
          Lu, Y., Supriya, K., Shaked, S., Simmons, E. H., & Kusenko, A.
          (2025). Incentivizing supplemental math assignments and using
          AI-generated hints is associated with improved exam performance.{' '}
          <em>Physical Review Physics Education Research.</em>
        </CitationCard>

        <div className={styles.cards}>
          {sourceCards.map((card) => (
            <article className={styles.card} key={card.eyebrow}>
              <p className={styles.cardEyebrow}>{card.eyebrow}</p>
              <h3>{card.title}</h3>
              <a href={card.href} rel="noopener noreferrer" target="_blank">
                {card.link}
              </a>
            </article>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
